interface PillIconProps {
  color?: string;
}

function PillIcon({ color = '#017993' }: PillIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-label="Drug coverage"
    >
      <rect width="24" height="24" rx="12" fill="" />
      <path
        d="M18.7996 5.20271C18.0294 4.43262 16.9848 4 15.8957 4C14.8065 4 13.7619 4.43262 12.9917 5.20271L5.16607 13.0274C4.4121 13.8007 3.99319 14.84 4.00008 15.92C4.00698 17 4.43913 18.0338 5.20291 18.7975C5.96669 19.5612 7.0006 19.9932 8.08066 19.9999C9.16072 20.0067 10.1999 19.5876 10.9732 18.8336L18.7996 11.0089C19.5683 10.2383 20 9.19428 20 8.10583C20 7.01737 19.5683 5.97334 18.7996 5.20271ZM17.9268 10.137L14.014 14.0489L9.95165 9.9874L13.8645 6.07469C14.4053 5.54635 15.1326 5.25253 15.8887 5.25695C16.6448 5.26137 17.3686 5.56367 17.9033 6.09828C18.4379 6.6329 18.7402 7.35673 18.7446 8.11278C18.749 8.86883 18.4552 9.59614 17.9268 10.137ZM16.7372 8.49787C16.7945 8.55515 16.84 8.62317 16.8711 8.69805C16.9021 8.77293 16.9181 8.85319 16.9181 8.93424C16.9181 9.0153 16.9021 9.09556 16.8711 9.17043C16.84 9.24531 16.7945 9.31333 16.7372 9.37061L14.8868 11.221C14.8295 11.2782 14.7615 11.3236 14.6866 11.3546C14.6118 11.3856 14.5315 11.4015 14.4505 11.4014C14.3695 11.4014 14.2893 11.3854 14.2145 11.3544C14.1397 11.3233 14.0717 11.2779 14.0144 11.2206C13.9572 11.1633 13.9118 11.0952 13.8808 11.0204C13.8498 10.9455 13.8339 10.8653 13.8339 10.7843C13.834 10.7033 13.85 10.6231 13.881 10.5483C13.912 10.4734 13.9575 10.4055 14.0148 10.3482L15.8652 8.49787C15.9809 8.38229 16.1377 8.31736 16.3012 8.31736C16.4647 8.31736 16.6215 8.38229 16.7372 8.49787Z"
        fill={color}
      />
    </svg>
  );
}

export default PillIcon;
